<div class="backdrop" (click)="onClose()"></div>
<div class="risorse-box">
    <div style="display: flex;">
        <div style="width: 50%;">
            <div class="modalHeader">
                {{ 'modResource.availableResource' | translate}}
            </div>
            <div class="risorsePanel" style="height: 80vh; overflow-y:scroll;">
                <app-resource-tree></app-resource-tree>
            </div>
        </div>
        <div style="width: 50%; ">
            <div class="modalHeader">
                {{ 'modResource.assignedResource' | translate}}
                <mat-icon class="chiudiModale" (click)="onClose()">highlight_off</mat-icon>
            </div>
            <div style="height: 80vh;">
                <ul>
                    <li class="risorsaAssegnata" *ngFor="let risorsa of assignedList; trackBy: trackByFn">
                        <mat-icon matTooltip="Rimuovi {{risorsa.index}}" (click)="onRemoveAssignedResource(risorsa.id)">
                            close</mat-icon>
                        <strong>{{risorsa.index}}</strong> - <span [innerHTML]="getTractateTitle(risorsa)"></span><span
                            [innerHTML]="risorsa.title | safeHtml"></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>